import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { Button, Box } from "@mui/material";
import AppInfoView from "@crema/core/AppInfoView";
import AppsContainer from "@crema/core/AppsContainer";
import AppsPagination from "@crema/core/AppsPagination";
import AppsContent from "@crema/core/AppsContainer/AppsContent";
import AppsHeader from "@crema/core/AppsContainer/AppsHeader";
import { AppState } from "redux/store";
import { getMapping } from "redux/actions/support";
import MappingTable from "./MappingTable";
import { MappingData } from "types/models/support/SupportApp";

const Mapping = () => {
  const { messages } = useIntl();
  const dispatch = useDispatch();
  const { mapping, mappingCount } = useSelector<AppState, AppState["support"]>(
    ({ support }) => support
  );

  const [page, setPage] = useState(0);
  const [search, setSearchQuery] = useState<string>("");

  const [dynamicRows, setDynamicRows] = useState<any[]>([]);

  const onPageChange = (
    event: React.ChangeEvent<unknown> | null,
    value: number
  ) => {
    setPage(value);
  };

  useEffect(() => {
    dispatch(getMapping(search, page));
  }, [dispatch, search, page]);


  // Handler to add a new row
  const onAddMapping = () => {
    setDynamicRows((prevRows) => [
      ...prevRows,
      {
        crmCategory: "",
        clientCategory: "",
        conditions: {},
        status: false,
      },
    ]);
  };

  // Handler to update row data
  const handleRowChange = (index: number, field: string, value: any) => {
    const updatedRows = [...dynamicRows];
    if (field === "conditions") {
      updatedRows[index][field][value] = !updatedRows[index][field][value]; 
    } else {
      updatedRows[index][field] = value;
    }
    setDynamicRows(updatedRows);
  };

  return (
    <>
      <AppsContainer
        title={
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Box
              component="span"
              sx={{
                fontSize: 16,
                fontWeight: "bold",
                color: "text.primary",
                flex: 1,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {messages["sidebar.support.viewMapping"]}
            </Box>
            <Button variant="outlined" color="primary" sx={{ flexShrink: 0 }} onClick={onAddMapping}>
              Add Mapping
            </Button>
          </Box>
        }
        fullView
      >
        <AppsHeader>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-end",
              width: 1,
            }}
          ></Box>
        </AppsHeader>

        <AppsContent
          sx={{
            paddingTop: 2.5,
            paddingBottom: 2.5,
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
          }}
        >
          <MappingTable
  mapping={(mapping as MappingData[]) || []}
  dynamicRows={dynamicRows}         
  handleRowChange={handleRowChange}   
/>
          <AppsPagination
            rowsPerPage={10}
            count={mappingCount}
            page={page}
            onPageChange={onPageChange}
          />
        </AppsContent>
      </AppsContainer>

      <AppInfoView />
    </>
  );
};

export default Mapping;
